<!-- カード関連で決済失敗 -->
<template>
  <ItemDialog ref="DialogCardAuthFailed" image-type="alert">
    <template #content-area>
      <h2>
        {{ $t("Errors.cardAuthFailed.title") }}
      </h2>
      <p class="text-center">
        {{ $t("Errors.cardAuthFailed.description") }}
      </p>
    </template>
    <template #button-area>
      <ItemButton label="OK" action-type="btn-primary" @clicked="closeDialog" />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogCardAuthFailed",
  setup(props) {
    const DialogCardAuthFailed = ref(null);

    const openDialog = () => {
      DialogCardAuthFailed.value.open();
    };

    // エラー時にBFF側でbook_groupが削除される。そのため、決済処理続行不可なのでTOPに戻す
    const closeDialog = () => {
      DialogCardAuthFailed.value.close();
      nativeHandlerService.returnNativeAppTopPage();
    };

    return {
      DialogCardAuthFailed,
      openDialog,
      closeDialog,
    };
  },
};
</script>
